import React from 'react';
import { Switch, Route } from 'react-router-dom';

import AdminLogin        from './AdminLogin.jsx';
import AdminDashboard    from './AdminDashboard.jsx';
import GenericManager    from './managers/GenericManager.jsx';
import ServicesManager   from './managers/ServicesManager.jsx';
import StaffManager      from './managers/StaffManager.jsx';
import SponsorsManager   from './managers/SponsorsManager.jsx';
import PublicationsManager from './managers/PublicationsManager.jsx';

const AdminApp = (props) => (
  <Switch>
    <Route exact path="/admin"              render={(p) => <AdminLogin {...p} />} />
    <Route exact path="/admin/dashboard"   render={(p) => <AdminDashboard {...p} />} />

    {/* Generic CRUD routes */}
    <Route exact path="/admin/news"        render={(p) => <GenericManager type="news"      {...p} />} />
    <Route exact path="/admin/projects"    render={(p) => <GenericManager type="projects"  {...p} />} />
    <Route exact path="/admin/trainings"   render={(p) => <GenericManager type="trainings" {...p} />} />
    <Route exact path="/admin/events"      render={(p) => <GenericManager type="events"    {...p} />} />

    {/* Specialised managers */}
    <Route exact path="/admin/services"    render={(p) => <ServicesManager    {...p} />} />
    <Route exact path="/admin/publications" render={(p) => <PublicationsManager {...p} />} />
    <Route exact path="/admin/staff"       render={(p) => <StaffManager       {...p} />} />
    <Route exact path="/admin/sponsors"    render={(p) => <SponsorsManager    {...p} />} />

    {/* Fallback: redirect unknown admin routes to dashboard */}
    <Route render={(p) => { p.history.replace('/admin/dashboard'); return null; }} />
  </Switch>
);

export default AdminApp;



// WEBPACK FOOTER //
// ./src/views/Admin/AdminApp.jsx